import React, { Component } from "react"
import styles from "./TypingIndicator.module.scss"
import Fade from "@material-ui/core/Fade";

export default class extends Component {

  render() {
    return (
      !!this.props.show && <Fade in={this.props.show}>
        <div className={styles.container}>
          <span className={styles.dot}/>
          <span className={styles.dot}/>
          <span className={styles.dot}/>
        </div>
      </Fade>
    )
  }
}
